import styled from "@emotion/styled";
import {eerieBlack} from "../../styles/colors";

export const PageBreak = styled.div`
  margin: 48px 0;
  width: 100%;
  height: 1px;
  background: ${eerieBlack[300]}
`
